import type { SVGProp } from './types';

export const plus = (props: SVGProp) => (
  <svg
    width={props.width || '24'}
    height={props.height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M19 11h-6V5c0-.26522-.1054-.51957-.2929-.70711C12.5196 4.10536 12.2652 4 12 4c-.2652 0-.5196.10536-.7071.29289C11.1054 4.48043 11 4.73478 11 5v6H5c-.26522 0-.51957.1054-.70711.2929C4.10536 11.4804 4 11.7348 4 12c0 .2652.10536.5196.29289.7071C4.48043 12.8946 4.73478 13 5 13h6v6c0 .2652.1054.5196.2929.7071.1875.1875.4419.2929.7071.2929.2652 0 .5196-.1054.7071-.2929.1875-.1875.2929-.4419.2929-.7071v-6h6c.2652 0 .5196-.1054.7071-.2929.1875-.1875.2929-.4419.2929-.7071 0-.2652-.1054-.5196-.2929-.7071C19.5196 11.1054 19.2652 11 19 11Z"
      fill="currentColor"
    />
  </svg>
);
